import { cn } from '@/lib/utils';

interface SkeletonProps extends React.HTMLAttributes<HTMLDivElement> {
  disablePulse?: boolean;
}

function Skeleton({
  className,
  disablePulse = false,
  ...props
}: SkeletonProps) {
  return (
    <div
      className={cn(
        'rounded-md bg-primary/10',
        !disablePulse && 'animate-pulse',
        className
      )}
      {...props}
    />
  );
}

export { Skeleton };
